 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import HTML9781607052302_01_COVER from '@/components/html/9781607052302_01_cover'
 import HTMLLOVE_1 from '@/components/html/love_1'
 import HTML9781607052302_02_TITLE from '@/components/html/9781607052302_02_title'
 import HTML9781607052302_03_COPY from '@/components/html/9781607052302_03_copy'
 import HTML9781607052302_04_TOC from '@/components/html/9781607052302_04_toc'
 import HTML9781607052302_05_DED from '@/components/html/9781607052302_05_ded'
 import HTML9781607052302_06_PREF from '@/components/html/9781607052302_06_pref'
 import HTML9781607052302_07_CH1 from '@/components/html/9781607052302_07_ch1'
 import HTML9781607052302_08_CH2 from '@/components/html/9781607052302_08_ch2'
 import HTML9781607052302_09_CH3 from '@/components/html/9781607052302_09_ch3'
 import HTML9781607052302_10_CH4 from '@/components/html/9781607052302_10_ch4'
 import HTML9781607052302_11_CH5 from '@/components/html/9781607052302_11_ch5'
 import HTML9781607052302_12_CH6 from '@/components/html/9781607052302_12_ch6'
 import HTML9781607052302_13_CH7 from '@/components/html/9781607052302_13_ch7'
 import HTMLLOVE_2 from '@/components/html/love_2'
 import HTML9781607052302_13A_PHOTO from '@/components/html/9781607052302_13a_photo'
 import HTML9781607052302_14_DESIGN from '@/components/html/9781607052302_14_design'
 import HTML9781607052302_15_ABT from '@/components/html/9781607052302_15_abt'
 import HTML9781607052302_16_GREAT from '@/components/html/9781607052302_16_great'
 import HTML9781607052302_17_CRAZY from '@/components/html/9781607052302_17_crazy'
 import HTML9781607052302_18_BACKMATTER from '@/components/html/9781607052302_18_backmatter'
 import HTML9781607052302_19_BACKCOVER from '@/components/html/9781607052302_19_backcover'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/html/9781607052302_04_toc",
 			"name" : "html/9781607052302_04_toc",
 			"component" : HTML9781607052302_04_TOC
 		},
 		{
 			"path" : "/html/9781607052302_05_ded",
 			"name" : "html/9781607052302_05_ded",
 			"component" : HTML9781607052302_05_DED
 		},
 		{
 			"path" : "/html/9781607052302_06_pref",
 			"name" : "html/9781607052302_06_pref",
 			"component" : HTML9781607052302_06_PREF
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js